import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ buttons: { buttonToggleGroup } }: ComposedTheme) => ({
  root: {
    color: buttonToggleGroup.fontColor,
    fontSize: buttonToggleGroup.fontSize,
    fontFamily: buttonToggleGroup.fontFamily,
    lineHeight: buttonToggleGroup.lineHeight,

    '&:not(:last-child):not(:active):not(:focus)': {
      borderRight: 'none',
    },

    '&:active + button, &:focus + button': {
      borderLeft: 'none',
    },

    '&:first-child': {
      borderRadius: `${buttonToggleGroup.borderRadius}px 0 0 ${buttonToggleGroup.borderRadius}px`,
    },

    '&:last-child': {
      borderRadius: `0 ${buttonToggleGroup.borderRadius}px ${buttonToggleGroup.borderRadius}px 0`,
    },

    background: buttonToggleGroup.toggleBackground,
    border: `1px solid ${buttonToggleGroup.toggleBorderColor}`,
    padding: buttonToggleGroup.togglePadding,

    '&$selected': {
      background: buttonToggleGroup.selectedToggleBackground,
      borderColor: buttonToggleGroup.selectedToggleBackground,
      color: buttonToggleGroup.selectedFontColor,
    },

    '&$selected svg': {
      fill: buttonToggleGroup.selectedFontColor,
    },

    '&:active, &:focus, &:hover': {
      background: buttonToggleGroup.selectedToggleBackground,
      borderColor: buttonToggleGroup.selectedToggleBackground,
      color: buttonToggleGroup.selectedFontColor,
    },

    '&:active, &:focus, &:hover svg': {
      fill: buttonToggleGroup.selectedFontColor,
    },

    '&:disabled': {
      backgroundColor: buttonToggleGroup.disabledBackground,
      borderColor: buttonToggleGroup.disabledBorder,
      color: buttonToggleGroup.disabledColor,
      cursor: 'not-allowed',
    },

    '&:disabled svg': {
      fill: buttonToggleGroup.disabledFill,
    },
  },

  selected: {},
});

export default createUseStyles(styles);
